export default function (value, nums) {
  return nums.reduce((prev, curr) => {
      return (Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev);
  });
}



// WEBPACK FOOTER //
// ./src/utils/getClosestNumberFromArray.js